import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { getRequiredLabAttachments } from '@core/src/nedoShared/features/consultations/helpers/requiredAttachments';
export const getLabResultsStatus = (status) => {
    let icon = null;
    let text = '';
    switch (status) {
        case 'pending':
            icon = _jsx(Icon, { type: "pending" });
            text = 'Pending';
            break;
        case 'veryfied':
            icon = _jsx(Icon, { type: "checkGreen" });
            text = 'Verified';
            break;
        case 'uploaded':
            icon = _jsx(Icon, { type: "exclamationPointYellow" });
            text = 'Uploaded';
            break;
        case 'rejected':
            icon = _jsx(Icon, { type: "rejected" });
            text = 'Rejected';
            break;
        default: {
            const _exhaustiveCheck = status;
            throw new Error(`Unhandled status param: ${_exhaustiveCheck}`);
        }
    }
    return {
        icon,
        text,
    };
};
export const deriveLabResultsStatus = (consultation) => {
    var _a;
    const required = getRequiredLabAttachments(consultation);
    const hasRequired = required.length > 0;
    if (!hasRequired) {
        return { status: null, hasRequired: false };
    }
    const hasUploadedLab = ((_a = consultation.attachments) !== null && _a !== void 0 ? _a : []).some((att) => att.type === 'lab_results');
    if (!hasUploadedLab) {
        return { status: 'pending', hasRequired: true };
    }
    const anyNotVerified = required.some((ra) => !ra.verified);
    if (anyNotVerified) {
        return { status: 'uploaded', hasRequired: true };
    }
    return { status: 'veryfied', hasRequired: true };
};
export const getLabResultsStatusComponent = (status, classes) => {
    const data = getLabResultsStatus(status);
    return (_jsxs("div", Object.assign({ className: classes === null || classes === void 0 ? void 0 : classes.wrapper }, { children: [_jsx("div", Object.assign({ className: classes === null || classes === void 0 ? void 0 : classes.icon }, { children: data.icon })), _jsx("div", Object.assign({ className: classes === null || classes === void 0 ? void 0 : classes.text }, { children: data.text }))] })));
};
export const renderLabResultsStatus = (consultation, classes) => {
    const { status, hasRequired } = deriveLabResultsStatus(consultation);
    if (!hasRequired)
        return '-';
    return status ? getLabResultsStatusComponent(status, classes) : '-';
};
export const getLabResultIcon = (consultation) => {
    const { status, hasRequired } = deriveLabResultsStatus(consultation);
    if (!hasRequired || !status)
        return null;
    return getLabResultsStatus(status).icon;
};
